export default {"src":"/_next/static/media/karting.4cbb4688.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};